import { useAuth0 } from '@auth0/auth0-react';
import { ApiErrorWrapper, useApi } from '@hooks/api.hook';
import { queryKeys } from '@queries/keys';
import { useQuery } from '@tanstack/react-query';
import { TargetSystemSelectDto, TargetSystemsSelectDto } from '../types/api.types';

/**
 * Hook to fetch all target systems from the API
 * @returns Query result containing array of target systems or error state
 */
export const useGetTargetSystems = () => {
  const { apiGet } = useApi();
  const { isAuthenticated } = useAuth0();
  const enabled = Boolean(isAuthenticated);

  return useQuery<TargetSystemSelectDto[], ApiErrorWrapper>({
    enabled,
    queryFn: async () => {
      const result = await apiGet<TargetSystemsSelectDto>({
        path: '/v1/data/target-systems',
      });
      return result.targetSystems;
    },
    queryKey: enabled ? queryKeys.targetSystem.getTargetSystems : queryKeys.placeholders.default,
  });
};
